import { UserRole } from "constants/userRole";
import { useUserWithAccount } from "context/UserAccountProvider";
import { Navigate } from "react-router-dom";

function withContractsLibraryAccess(Component: React.ComponentType<any>) {
  return function ContractsLibraryProtectedComponent(props: any) {
    const { userInfo } = useUserWithAccount();

    if (!userInfo) {
      return <Navigate to="/login" />;
    }

    // Allow SuperAdmin full access
    if (userInfo.scope === UserRole.SUPER_ADMIN) {
      return <Component {...props} />;
    }

    // Allow HospitalStaff with contractsLibraryEnabled
    if (
      userInfo.scope === UserRole.HOSPITAL_STAFF &&
      userInfo.contractsLibraryEnabled
    ) {
      return <Component {...props} />;
    }

    // Redirect unauthorized users
    return <Navigate to="/" />;
  };
}

export default withContractsLibraryAccess;
